module.exports = __webpack_public_path__ + "static/3dmodel03-dcc945416e12ef94752a893fd1d0ee30.jpg";